import React from 'react';
import classNames from 'classnames';

export const ViewingRecords = ({
  limit,
  offset,
  count,
  className,
  ...props
}) => (
  <div className={classNames('text-muted small', className)} {...props}>
    Viewing {offset + 1} - {Math.min(offset + limit, count)} of {count} records
  </div>
);

export default ViewingRecords;



// WEBPACK FOOTER //
// ./src/components/common/Tables/ViewingRecords.jsx